import React from "react";
import * as palette from "@govlaunch/palette";

export default function ProfileBox({ children, ...props }: { children: React.ReactNode }) {
  return (
    <div
      css={{
        backgroundColor: palette.white,
        borderRadius: 5,
        border: `solid 1px ${palette.lightestGray}`,
      }}
      {...props}
    >
      {children}
    </div>
  );
}
